module.exports = __webpack_public_path__ + "static/images/upload.31HIF0x.svg";